import { Component, OnInit, OnDestroy } from '@angular/core';
import { CustomersService } from 'src/app/customers/customers.service';
import { ActivatedRoute, Router } from "@angular/router";
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import * as _ from 'underscore';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { UsersService } from 'src/app/users/users.service';
import { TranslateService } from '@ngx-translate/core';
import { SitesService } from 'src/app/sites/sites.service';
import * as moment from 'moment';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceFactory } from '../../site-dashboard/device/device-factory/device-factory';
import { DeviceService } from '../../site-dashboard/device/device.service';

@Component({
	selector: 'app-customer-info',
	templateUrl: './customer-info.component.html',
	styleUrls: ['./customer-info.component.css']
})
export class CustomerInfoComponent implements OnInit, OnDestroy {
	DeviceFactory = DeviceFactory;
	customerId: number = 0;
	customer: any = {};
	dataSub: any;
	sites = [];
	devices = [];
	sitesById: any = {};
	sitesPerformanceData;
	allDevicesCount = 0;
	infoBoxSiteAnalytics: any;
	siteMapClickedSiteSub: any = {};
	quarterlyReportCols: any[] = [];
	monthlyReportCols: any[] = [];
	quarterData: any = [];
	monthData: any = [];
	battlinkMonthData: any = [];
	quartersList: any[] = [];
	yearList: any[] = [];
	battlinkYearList: any[] = [];
	monthList: any[] = [];
	battlinkMonthList: any[] = [];
	selectedQuarterData: any[];
	selectedMonthData: any[];
	battlinkSelectedMonthData: any[];
	quarterReportFilters: any = {
		quarter: '',
		site: []
	};
	monthReportFilters: any = {
		year: '',
		month: '',
		site: []
	};
	battlinkMonthReportFilters: any = {
		year: '',
		month: '',
		site: []
	};
	tooltips = {
		customer_contact_info: '',
		quarterly_customer_report: '',
		monthly_customer_report: '',
		customer_notes: ''
	};
	currentMonth = moment().format('MMMM');
	currentYear = moment().format('YYYY');
	maintenanceReport: any = {};
	maintenanceConfig: any = {};
	siteDeviceMaintenance: any = {};
	hasMaintenanceAccess: boolean = false;
	currentUser: any = {};
	chargLinkDevicesMacAddresses = [];
	chargLinkDevices = [];
	iotahDevices = [];
	battlinkDevices = [];
	allBattlinkDevices = [];
	totalUtilizationEnergy = { months: {} };
	trucksReportConfig: any = {
		table: {
			hasPagination: false,
			fileName: '',
			draggable: true,
			hasExport: true,
			csvFileHeaderInfo: [],
		},
		columns: [
			{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: "link" },
			{ key: 'site_address', name: this.translateService.instant('site_edit.address'), type: 'string' },
			{ key: 'trucks_count', name: this.translateService.instant('site.number_of_trucks'), type: 'number' },
			{ key: 'truck_utilization_score', name: this.translateService.instant('site.utilization_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.sites_summary_utilization') },
			{ key: 'truck_utilization_energy_score', name: this.translateService.instant('site.energy_utilization_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.sites_summary_energy_utilization') },
			{ key: 'total_ahr', name: this.translateService.instant('site.ioTAh_devices.total_truck_inuse_ah'), type: "number"},
			{ key: 'total_kwhr', name: this.translateService.instant('site.ioTAh_devices.total_truck_inuse_kWh'), type: "number" },
		],
		data: []
	}

	battlinkReportConfig: any = {
		table: {
			hasPagination: false,
			fileName: '',
			draggable: true,
			hasExport: true,
			csvFileHeaderInfo: [],
		},
		columns: [
			{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: "link" },
			{ key: 'site_address', name: this.translateService.instant('site_edit.address'), type: 'string' },
			{ key: 'batteries_count', name: this.translateService.instant('site.number_of_batteries'), type: 'number' },
			{ key: 'battery_utilization_score', name: this.translateService.instant('battlinkDevice.site.utilization_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.battlinkDevice.sites_summary_utilization') },
			{ key: 'battery_energy_utilization_score', name: this.translateService.instant('battlinkDevice.site.energy_utilization_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.battlinkDevice.sites_summary_energy_utilization') },
			{ key: 'total_battery_charge_ah', name: this.translateService.instant('site.battLink_devices.total_charge_ah'), type: "number"},
			{ key: 'total_battery_inuse_ah', name: this.translateService.instant('site.battLink_devices.total_inuse_ah'), type: "number" },
		],
		data: []
	}

	chargersReportConfig: any = {
		table: {
			hasPagination: false,
			fileName: '',
			draggable: true,
			hasExport: true,
			csvFileHeaderInfo: [],
		},
		columns: [
			{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: "link" },
			{ key: 'site_address', name: this.translateService.instant('site_edit.address'), type: 'string' },
			{ key: 'chargers_count', name: this.translateService.instant('site.number_of_charger'), type: 'number' },
			{ key: 'charger_utilization_score', name: this.translateService.instant('chargLinkDevice.site.utilization_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.chargLinkDevice.sites_summary_utilization') },
			{ key: 'chargers_total_ahr', name: this.translateService.instant('site.battLink_devices.total_charge_ah'), type: "number"},
			{ key: 'chargers_total_kwhr_calc', name: this.translateService.instant('devices.charge_kwhr'), type: "number" },
		],
		data: []
	}

	periodFilters = [
		{ id: 'annually', label: this.translateService.instant('g.annually') },
		{ id: 'quarterly', label: this.translateService.instant('g.quarterly') },
		{ id: 'monthly', label: this.translateService.instant('g.monthly') }
	];

	summaryChargersReportYearsOption: any = [];
	selectedSummaryChargersYear;

	chargerMonthly = {};
	chargerQuarterly = {}
	nonSpecialSites = [];

	/**
	 * ST-2448: the chart inputs below are held as fields, not built in the template.
	 * A method call or an object literal in a binding hands Angular a new reference on
	 * every change-detection pass, so each chart would see its inputs as changed, rerun
	 * ngOnChanges and rebuild its Google Charts table every tick - which locks the page up.
	 */
	iotahSites = [];
	chargLinkSites = [];
	battlinkSites = [];
	chartSiteInfo: { id: number, name: string } = { id: 0, name: '' };

	readonly truckChartOptions = { hasTruckTypeFilter: true, hasStackedColumn: true, hasSiteFilter: true, hasQuarterlyMonthlyFilter: true };
	readonly chargerChartOptions = { hasTruckTypeFilter: false, hasStackedColumn: false, hasSiteFilter: true, hasQuarterlyMonthlyFilter: true };
	readonly batteryChartOptions = { hasTruckTypeFilter: false, hasStackedColumn: false, hasSiteFilter: true, hasQuarterlyMonthlyFilter: true };
	chargerSummaryReportPeriodType: string = 'quarterly';

	tableConfigChargersReport: TableConfig = {
		hasExport: true,
		hasPagination: false,
		fileName: '',
		draggable: true,
		csvFileHeaderInfo: [],
	};

	customerSitesPermissions: any = {}

	/**Installed Device type widget */
	installedCustomerIotahDeviceTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			fileName: this.translateService.instant('site.site_devices')
		} as TableConfig
	};

	installedCustomerChargersDeviceTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			fileName: this.translateService.instant('chargLinkDevice.site.site_devices')
		} as TableConfig
	};

	installedCustomerBatteryDeviceTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			fileName: this.translateService.instant('battlinkDevice.site.site_devices')
		} as TableConfig
	};

	isInstalledWidgetPrepared: boolean = false;

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		_installation_date_ms: TimeSource.Utc,
		last_connect_time_formatted: TimeSource.PcTime,
	};

	constructor(
		private route: ActivatedRoute,
		public router: Router,
		private customersService: CustomersService,
		private sideMenuService: SideMenuService,
		public userService: UsersService,
		public commonService: CommonService,
		private translateService: TranslateService,
		public sitesService: SitesService,
		private deviceService: DeviceService,
	) {}

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUser();

		for(let key in this.tooltips) {
			this.tooltips[key] = this.commonService.getTooltipKey(key, this.userService.userHasNOCAccess());
		}

		this.sideMenuService.setRouteHasSiteInfoBox(true);
		this.hasMaintenanceAccess = this.userService.hasAccessPermission({}, 'last_pm_date');

		this.reset();

		let customerId = parseInt(this.route.snapshot.params.customerId);
		if (customerId) {
			this.customerId = customerId;
			this.getCustomer(customerId);

			this.quarterlyReportCols = [
				{
					headerName: "g.site_name", field: "site_name",
					cellRendererSelector:function (params) {
						params['label'] = params.data.site_name;
						params['link'] = ["/", params.colDef.cellRendererParams.customerId, params.data.site_id].join('/');
						return {
							component: 'linkCellRenderer',
							params: params
						};
					},
					cellRendererParams: {customerId: customerId},
				},
				{headerName: "site_edit.address", field: "site_address"},
				{headerName: "site.number_of_charger", field: "chargers_count"},
				{headerName: "site.chargLink_devices.total_ahr", field: "chargers_total_ahr", type: 'number', filterParams: {format: '1.0-2'}},
				{headerName: "site.chargLink_devices.total_trucks_kwhr", field: "chargers_total_kwhr_calc", type: 'number', filterParams: {format: '1.0-2'}}

			];

			this.monthlyReportCols = [
				{
					headerName: "g.site_name", field: "site_name",
					cellRendererSelector:function (params) {
						params['label'] = params.data.site_name;
						params['link'] = ["/", params.colDef.cellRendererParams.customerId, params.data.site_id].join('/');
						return {
							component: 'linkCellRenderer',
							params: params
						};
					},
					cellRendererParams: {customerId: customerId},
				},
				{headerName: "site_edit.address", field: "site_address"},
				{headerName: "site.number_of_trucks", field: "trucks_count"},
				{headerName: "site.ioTAh_devices.total_ahr", field: "total_ahr", type: 'number', filterParams: {format: '1.0-2'}},
				{headerName: "site.ioTAh_devices.total_trucks_kwhr", field: "total_kwhr", type: 'number', filterParams: {format: '1.0-2'}},
			];
		}

		this.siteMapClickedSiteSub = this.sideMenuService.sitesMapClickedSite.subscribe((data: any) => {
			if (data && data.id) {
				this.sideMenuService.setSiteInfoBoxVisibility(true);
			}
		});

	}

	prepareQuarterlyReport() {
		if(!this.customer.sitesAnalytics)
			return;

		this.quarterData = [];
		const sitesAnalytics = this.customer.sitesAnalytics;
		this.quarterData = sitesAnalytics.usageData.qReport;
		if(!Object.keys(this.quarterData).length)
			return;

		this.monthData = this.quarterData.iotah;
		this.battlinkMonthData = this.quarterData.battlink;
		this.quarterData = this.quarterData.chargLink;

		this.formatChargerSummaryReportData();

		let sorterY = _.sortBy(Object.keys(this.monthData)).reverse();
		for(let y of sorterY) {
			this.yearList.push({
				id: y,
				label: y
			});
		}

		if(this.yearList.length) {
			this.monthReportFilters.year = this.yearList[0].id;

			this.setMonthList();
			if(this.monthList.length) {
				this.loadMonthData();
			}
		}

		// Battlink

		let battlinkSorterY = _.sortBy(Object.keys(this.battlinkMonthData)).reverse();
		for(let y of battlinkSorterY) {
			this.battlinkYearList.push({
				id: y,
				label: y
			});
		}

		if(this.battlinkYearList.length) {
			this.battlinkMonthReportFilters.year = this.battlinkYearList[0].id;

			this.setBattlinkMonthList();
			if(this.battlinkMonthList.length) {
				this.loadBattlinkMonthData();
			}
		}
	}

	formatChargerSummaryReportData() {
		this.summaryChargersReportYearsOption = [];
		this.quartersList = [];
		this.quarterReportFilters.quarter = []

		const years = _.sortBy(Object.keys(this.quarterData), y => +y).reverse();
		this.summaryChargersReportYearsOption = years.map(y => ({ id: y, label: y }));
		this.selectedSummaryChargersYear = this.selectedSummaryChargersYear || this.summaryChargersReportYearsOption[0]?.id;

		const rawPeriods = Object.keys(this.quarterData[this.selectedSummaryChargersYear] || []);
		const months = [];
		const quarters = [];

		for (const key of rawPeriods) {
			if (/^Q\d$/.test(key))
				quarters.push(key);
			else
				months.push(+key);
		}

		const selectedQuarters = _.sortBy(quarters).map(q => ({ id: q, label: q }));
		const selectedMonths = _.sortBy(months).map(m => ({ id: m, label: moment(m, 'MM').format('MMMM') }));

		this.quartersList = this.chargerSummaryReportPeriodType === 'quarterly' ? selectedQuarters : selectedMonths;
		this.quarterReportFilters.quarter = this.quartersList.length ? this.quartersList[0].id : null;
		
		if (this.chargerSummaryReportPeriodType == 'annually')
			this.loadAnnuallyData(quarters);
		else
			this.loadQuarterData();
	}

	setMonthList() {
		let sorterM = _.sortBy(Object.keys(this.monthData[this.monthReportFilters.year]).map(key => +key));
		this.monthList = [];
		for(let m of sorterM) {
			this.monthList.push({
				id: m,
				label: moment(m, 'MM').format('MMMM')
			});
		}
		this.monthReportFilters.month = this.monthReportFilters.year == this.currentYear ? (this.monthList.filter(month => month.label == this.currentMonth))[0].id : this.monthList[0].id;
	}

	setBattlinkMonthList() {
		let sorterM = _.sortBy(Object.keys(this.battlinkMonthData[this.battlinkMonthReportFilters.year]).map(key => +key));
		this.battlinkMonthList = [];
		for(let m of sorterM) {
			this.battlinkMonthList.push({
				id: m,
				label: moment(m, 'MM').format('MMMM')
			});
		}
		this.battlinkMonthReportFilters.month = this.battlinkMonthReportFilters.year == this.currentYear ? (this.battlinkMonthList.filter(month => month.label == this.currentMonth))[0].id : this.battlinkMonthList[0].id;
	}

	getCustomer(customerId) {
		this.customersService.getCustomer(customerId, { get_devices_counts: true, check_has_studies: true, retrieveCustomerDevicesOnly: true, exclude_special_site: true, include_zombie_sites: true, getSitesPermission: true }).subscribe(
			(data: any) => {
				if(data == 'not_found')
					return this.router.navigateByUrl('/404');

				this.customer = data;
				this.chartSiteInfo = { id: this.customer.id, name: this.customer.customer_name };

				this.commonService.setPageTabTitle(`${this.customer.customer_name} ${this.translateService.instant('customer.customer_info')}`);
				const csvFileHeadersInfo = this.commonService.getCsvFileHeadersInfo({ customerName: this.customer.customer_name, includeSpacing: false });
				this.trucksReportConfig.table.csvFileHeaderInfo = csvFileHeadersInfo
				this.battlinkReportConfig.table.csvFileHeaderInfo = csvFileHeadersInfo;
				this.chargersReportConfig.table.csvFileHeaderInfo = csvFileHeadersInfo;
				this.tableConfigChargersReport.csvFileHeaderInfo = csvFileHeadersInfo;

				for (const siteId in data.sites_devices_counts) {
					this.allDevicesCount += +data.sites_devices_counts[siteId];
				}

				if(this.customer.devices) {
					this.devices = this.customer.devices;
					const {
						iotahDevices, charglinkdDevices, battlinkDevices, lithiumBattlinkDevices, battlinkIIDevices, brmDevices
					} = DeviceFactory.group(this.devices);
					this.chargLinkDevices = charglinkdDevices.concat(brmDevices);
					this.iotahDevices = iotahDevices;
					this.battlinkDevices = battlinkDevices;
					// ST-2549: the battery charts draw every battery type, as the charger ones include BRM
					this.allBattlinkDevices = [...battlinkDevices, ...lithiumBattlinkDevices, ...battlinkIIDevices];
					this.chargLinkDevicesMacAddresses = this.chargLinkDevices.map(device => device.mac_address);
				}

				for (const siteId in data.permissionBySiteId) {
					this.customerSitesPermissions[siteId] = this.commonService.revertPermissionValue(data.permissionBySiteId[siteId].permissions);
				}

				if(this.customer.sitesAnalytics) {
					this.sitesPerformanceData = this.customer.sitesAnalytics.usageData;
					this.aggregateSitesAnalytics(this.customer.sitesAnalytics);
					this.calculateUtilizationScore(this.customer.sitesAnalytics.generatedSiteData, this.customer.sitesAnalytics.totalBatteryCapacityPerType);
				}

				this.trucksReportConfig.table.fileName = this.translateService.instant('site.ioTAh_devices.site_summary_report', {customer: this.customer.customer_name});
				this.chargersReportConfig.table.fileName = this.translateService.instant('site.quarterly_customer_report', {customer: this.customer.customer_name})
				this.battlinkReportConfig.table.fileName = this.translateService.instant('site.battLink_devices.site_summary_report', {customer: this.customer.customer_name});

				this.dataSub = this.sideMenuService.data.subscribe((d:any)=> {
					if(d.length !=0) {
						const customers = _.indexBy(d, "id");
						const customer = customers[customerId];
						this.sideMenuService.setCurrentCustomer(customer);
						this.sites = customer.sites;
						this.filterSpecialSites();
						this.sitesById = _.indexBy(this.sites, 'id');
						this.prepareQuarterlyReport();

						// handle installed device widget
						if(!this.isInstalledWidgetPrepared) {
							this.handleDeviceTypeInstalledWidget();
							this.isInstalledWidgetPrepared = true;
						}
					}
				});
			}
		);
	}

	getDevicesPerformanceData(sitesAnalytics) {
		let sitesData:any = Object.values(sitesAnalytics);
		let result = [];
		for(let i in sitesData)
			result.push(...sitesData[i]);

		return result;
	}

	reset() {
		this.sideMenuService.setSitesMapClickedSite({});
		this.sideMenuService.setCurrentSite({});
	}

	ngOnDestroy() {
		if(this.dataSub)
			this.dataSub.unsubscribe();
		this.reset();
		this.siteMapClickedSiteSub.unsubscribe();
		this.sideMenuService.setRouteHasSiteInfoBox(false);
	}

	chargeUtilizationScore(usedDevicesDaysCount: number, devicesCount: number, periodValue: number, periodKey: string) {
		if (!usedDevicesDaysCount)
			return 0;

		const totalDaysInPeriod = this.commonService.getTotalDaysInPeriod(periodValue, periodKey);
		return Math.round((usedDevicesDaysCount / (devicesCount * totalDaysInPeriod)) * 100);
	}

	loadAnnuallyData(quarters) {
		const aggregatedDataPerSite: any = {};
		for (const quarter of quarters) {
			this.selectedQuarterData = _.filter(this.quarterData[this.selectedSummaryChargersYear][quarter], (site: any) => {
				return !this.quarterReportFilters.site.length || this.quarterReportFilters.site.includes(+site.site_id);
			});

			for (const row of this.selectedQuarterData as any[]) {
				if (!aggregatedDataPerSite[row.site_id]) {
					aggregatedDataPerSite[row.site_id] = {
						site_id: row.site_id,
						site_name: row.site_name,
						site_address: row.site_address,
						is_smart_rebates: row.is_smart_rebates,
						state_id: row.state_id,
						chargers_count: row.chargers_count || 0,
						chargers_total_ahr: 0,
						chargers_total_kwhr: 0,
						chargers_billed_kwhr: 0,
						used_charger_days_count: 0
					};
				}

				aggregatedDataPerSite[row.site_id].used_charger_days_count += row.used_charger_days_count || 0;
				aggregatedDataPerSite[row.site_id].chargers_total_ahr += row.chargers_total_ahr || 0;
				aggregatedDataPerSite[row.site_id].chargers_total_kwhr += row.chargers_total_kwhr || 0;
				aggregatedDataPerSite[row.site_id].chargers_billed_kwhr += row.chargers_billed_kwhr || 0;
			}
		}

		const yearData: any[] = Object.values(aggregatedDataPerSite);

		const tableData = [];
		let totalAhr = 0;
		let totalKwhr = 0;
		let totalCount = 0;
		let utilizationScoreSum = 0;

		for (const row of yearData) {
			const chargersTotalKWh = (row.is_smart_rebates && ![this.commonService.usaStates.oregon, this.commonService.usaStates.california].includes(row.state_id)) ? row.chargers_billed_kwhr : row.chargers_total_kwhr;
			row.chargers_total_kwhr = chargersTotalKWh;
			
			const chargerUtilizationScore = this.chargeUtilizationScore(row.used_charger_days_count, row.chargers_count, this.selectedSummaryChargersYear, 'years');

			tableData.push({
				site_name: { value: row.site_name, link: ['/', this.customerId, row.site_id] },
				site_address: { value: row.site_address },
				chargers_count: { value: row.chargers_count },
				charger_utilization_score: { value: Math.round(chargerUtilizationScore) || 0 },
				chargers_total_ahr: { value: Math.round(+row.chargers_total_ahr || 0).toLocaleString() },
				chargers_total_kwhr_calc: { value: Math.round(+row.chargers_total_kwhr || 0).toLocaleString() },
			});

			totalAhr += row.chargers_total_ahr || 0;
			totalKwhr += row.chargers_total_kwhr || 0;
			totalCount += row.chargers_count || 0;
			utilizationScoreSum += (chargerUtilizationScore / 100) * row.chargers_count || 0;
		}

		if (tableData.length) {
			tableData.push({
				site_name: { value: 'Total', bold: true },
				site_address: { value: '' },
				chargers_count: { value: totalCount },
				charger_utilization_score: { value: totalCount ? Math.round((utilizationScoreSum / totalCount) * 100) :  0 },
				chargers_total_ahr: { value: Math.round(totalAhr || 0).toLocaleString() },
				chargers_total_kwhr_calc: { value: Math.round(totalKwhr || 0).toLocaleString() },
			})
		}

		this.chargersReportConfig.data = tableData;
	}

	loadQuarterData() {
		this.selectedQuarterData = _.filter(this.quarterData?.[this.selectedSummaryChargersYear]?.[this.quarterReportFilters.quarter] || [], (site) => {
			return !this.quarterReportFilters.site.length || this.quarterReportFilters.site.includes(+site.site_id);
		});

		const tableData = [];
		let totalAhr = 0;
		let totalKwhr = 0;
		let totalCount = 0;
		let utilizationScoreSum = 0;

		for (const row of this.selectedQuarterData) {
			const chargersTotalKWh = (row.is_smart_rebates && ![this.commonService.usaStates.oregon, this.commonService.usaStates.california].includes(row.state_id)) ? row.chargers_billed_kwhr : row.chargers_total_kwhr;
			row.chargers_total_kwhr = chargersTotalKWh;

			tableData.push({
				site_name: { value: row.site_name, link: ['/', this.customerId, row.site_id] },
				site_address: { value: row.site_address },
				chargers_count: { value: row.chargers_count },
				charger_utilization_score: { value: Math.round(row.charger_utilization_score) || 0},
				chargers_total_ahr: { value: Math.round(+row.chargers_total_ahr || 0).toLocaleString() },
				chargers_total_kwhr_calc: { value: Math.round(+row.chargers_total_kwhr || 0).toLocaleString() },
			});

			totalAhr += row.chargers_total_ahr || 0;
			totalKwhr += row.chargers_total_kwhr || 0;
			totalCount += row.chargers_count || 0;
			utilizationScoreSum += (row.charger_utilization_score / 100) * row.chargers_count || 0;
		}

		if (tableData.length) {
			tableData.push({
				site_name: { value: 'Total', bold: true },
				site_address: { value: '' },
				chargers_count: { value: totalCount },
				charger_utilization_score: { value: totalCount ? Math.round((utilizationScoreSum / totalCount) * 100) :  0 },
				chargers_total_ahr: { value: Math.round(totalAhr || 0).toLocaleString() },
				chargers_total_kwhr_calc: { value: Math.round(totalKwhr || 0).toLocaleString() },
			})
		}

		this.chargersReportConfig.data = tableData;
	}

	loadMonthData(updateMonthList=false) {
		if(updateMonthList)
			this.setMonthList();

		this.selectedMonthData = _.filter(this.monthData[this.monthReportFilters.year][this.monthReportFilters.month], (site) => {
			return !this.monthReportFilters.site.length || this.monthReportFilters.site.includes(+site.site_id);
		});

		const tableData = [];
		let totalAhr = 0;
		let totalKwhr = 0;
		let totalCount = 0;
		let utilizationScoreSum = 0;

		for (const row of this.selectedMonthData) {
			const shouldDisablePowerStudySiteLink =
				(!this.currentUser.isSCT ||
				!this.userService.hasAccessFunction('has_power_study')) &&
				row.site_name == this.commonService.powerStudiesDevicesSiteName

			const siteLink = !shouldDisablePowerStudySiteLink ? ['/', this.customerId, row.site_id] : null;

			tableData.push({
				site_name: { value: row.site_name, link: siteLink },
				site_address: { value: row.site_address },
				trucks_count: { value: row.trucks_count },
				truck_utilization_score: { value: Math.round(row.truck_utilization_score) || 0},
				truck_utilization_energy_score: { value: Math.round(row.truck_utilization_energy_score) || 0 },
				total_ahr: { value: Math.round(+row.total_ahr || 0).toLocaleString() },
				total_kwhr: { value: Math.round(+row.total_kwhr || 0).toLocaleString() },
			});

			totalAhr += row.total_ahr || 0;
			totalKwhr += row.total_kwhr || 0;
			totalCount += row.trucks_count || 0;
			utilizationScoreSum += row.truck_utilization_score * row.trucks_count || 0;
		}

		const yearMonth = `${this.monthReportFilters.year}_${this.monthReportFilters.month}`;
		if (tableData.length) {
			tableData.push({
				site_name: { value: 'Total', bold: true },
				site_address: { value: '' },
				trucks_count: { value: totalCount },
				truck_utilization_score: { value: totalCount ? Math.round((utilizationScoreSum / totalCount)) : 0 },
				truck_utilization_energy_score: { value: totalCount ? Math.round((this.totalUtilizationEnergy.months[yearMonth].totalTruckEnergyScore)) : 0 },
				total_ahr: { value: Math.round(+totalAhr || 0).toLocaleString() },
				total_kwhr: { value: Math.round(+totalKwhr || 0).toLocaleString() },
			})
		}

		this.trucksReportConfig.data = tableData;
	}

	loadBattlinkMonthData(updateMonthList=false) {
		if(updateMonthList)
			this.setBattlinkMonthList();

		this.battlinkSelectedMonthData = _.filter(this.battlinkMonthData[this.battlinkMonthReportFilters.year][this.battlinkMonthReportFilters.month], (site) => {
			return !this.battlinkMonthReportFilters.site.length || this.battlinkMonthReportFilters.site.includes(+site.site_id);
		});

		const tableData = [];
		let totalInuseAhr = 0;
		let totalChargeAh = 0;
		let totalCount = 0;
		let utilizationScoreSum = 0;

		for (const row of this.battlinkSelectedMonthData) {
			tableData.push({
				site_name: { value: row.site_name, link: ['/', this.customerId, row.site_id] },
				site_address: { value: row.site_address },
				batteries_count: { value: row.batteries_count || 0 },
				battery_utilization_score: { value: Math.round(row.battery_utilization_score) || 0 },
				battery_energy_utilization_score: { value: Math.round(row.battery_utilization_energy_score) || 0 },
				total_battery_inuse_ah: { value: Math.round(+row.total_battery_inuse_ah || 0).toLocaleString() },
				total_battery_charge_ah: { value: Math.round(row.total_battery_charge_ah || 0).toString() },
			});

			totalInuseAhr += row.total_battery_inuse_ah || 0;
			totalChargeAh += row.total_battery_charge_ah || 0;
			totalCount += row.batteries_count || 0;
			utilizationScoreSum += (row.battery_utilization_score /100) * row.batteries_count || 0;
		}

		const yearMonth = `${this.battlinkMonthReportFilters.year}_${this.battlinkMonthReportFilters.month}`;
		if (tableData.length) {
			tableData.push({
				site_name: { value: 'Total', bold: true },
				site_address: { value: '' },
				batteries_count: { value: totalCount },
				battery_utilization_score: { value: totalCount ? Math.round((utilizationScoreSum / totalCount) * 100) : 0 },
				battery_energy_utilization_score: { value: totalCount ? Math.round(this.totalUtilizationEnergy.months[yearMonth].totalBattlinkEnergyScore) : 0},
				total_battery_inuse_ah: { value: Math.round(+totalInuseAhr || 0).toLocaleString() },
				total_battery_charge_ah: { value: Math.round(+totalChargeAh || 0).toLocaleString() },
			})
		}
		this.battlinkReportConfig.data = tableData;
	}

	private aggregateSitesAnalytics(sitesAnalytics) {
		this.infoBoxSiteAnalytics = {
			ioTAhDevices: sitesAnalytics.infoBox.since_installation.ioTAh_devices,
			chargLinkDevices: sitesAnalytics.infoBox.since_installation.chargLink_devices,
			battlinkDevices: sitesAnalytics.infoBox.since_installation.battLink_devices,
			iotemeterDevices: sitesAnalytics.infoBox.since_installation.iotemeter_devices,
		}
	}

	shouldShowStudiesSection() {
		return this.currentUser.has_access_to_any_study && this.customer.has_studies;
	}

	calculateUtilizationScore(customerSitesData, batteryCapacity) {
		const result = { months: {} };
		const periods = ['months'];

		const truckCapacity = 0.8 * (batteryCapacity?.iotah || 0);
		const battlinkCapacity = 0.8 * (batteryCapacity?.battlink || 0);

		const computeTotalEnergyScore = (energyUsed, capacity, days) => {
			return energyUsed ? ((energyUsed / 3600) * 100) / (capacity * days) : 0;
		};

		for (const period of periods) {
			const dataPerPeriod = customerSitesData?.[period];

			for (const label in dataPerPeriod) {
				const data = dataPerPeriod[label];
				const totalDaysInPeriod = this.commonService.getTotalDaysInPeriod(label, period);

				result[period][label] = {
					totalTruckEnergyScore: computeTotalEnergyScore(data.total_inuse_as_from_inuse_events_only, truckCapacity, totalDaysInPeriod),
					totalBattlinkEnergyScore: computeTotalEnergyScore(data.battery_total_inuse_as_from_inuse_events_only, battlinkCapacity, totalDaysInPeriod),
				};
			}
		}

		return this.totalUtilizationEnergy = result;
	}

	filterSpecialSites() {
		if (!this.sites.length)
			return;

		this.nonSpecialSites = this.sites.filter(site => !site.is_special);

		this.iotahSites = this.getSitesForDevices(this.iotahDevices);
		this.chargLinkSites = this.getSitesForDevices(this.chargLinkDevices);
		this.battlinkSites = this.getSitesForDevices(this.allBattlinkDevices);
	}

	/**
	 * ST-2448: each chart's site filter lists only the sites that actually have a device of
	 * that chart's type - offering a site with no chargers on the charger chart just gives
	 * the user an option that can never draw a bar.
	 *
	 * Sites with the right device type but no readings stay in the list on purpose: the
	 * chart says "no data to show" for them rather than pretending they were never live.
	 */
	getSitesForDevices(devices: any[]) {
		if (!devices?.length)
			return [];

		const siteIds = new Set(devices.map(device => String(device.site_id)));
		return this.nonSpecialSites.filter(site => siteIds.has(String(site.id)));
	}

	/** Installed Devices Widget */
	handleDeviceTypeInstalledWidget() {
		this.devices = this.formatDeviceFields(this.devices);
		const { iotahDevices, charglinkdDevices, battlinkDevices, lithiumBattlinkDevices, battlinkIIDevices, brmDevices } = DeviceFactory.group(this.devices);
		const chargeLinkDevices = charglinkdDevices.concat(brmDevices);
		this.allBattlinkDevices = [...battlinkDevices, ...lithiumBattlinkDevices, ...battlinkIIDevices];

		this.prepareInstalledTruckWidget(iotahDevices);
		this.prepareInstalledChargesWidget(chargeLinkDevices);
		this.prepareInstalledBatteryWidget(this.allBattlinkDevices);
	}

	formatDeviceFields(devices) {
		devices.forEach((device) => {
			device.last_connect_time = moment(device.last_connect_time).utc().unix();
			device.installation_date = moment(device.installation_date).utc().unix();

			let deviceVPC = (device.vpc !== undefined) ? device.vpc : ((device.battery_type == this.deviceService.batteryTypesByName.lithuim_ion) ? 3 : 2);
			const voltage = (device.number_of_cells * deviceVPC);
			device._voltage = voltage;
			device._installation_date_ms = device.installation_date * 1000;

			device.fw_version = this.commonService.toFixedWithoutRounding(device.fw_version, this.userService.getCurrentUser().is_admin ? 4 : 2);
			device.last_connect_time_formatted = moment(device.last_connect_time * 1000).format('MM/DD/YYYY HH:mm:ss');
			device.connectivity_verfication_status_formatted = this.translateService.instant(`g.${this.commonService.getDeviceConnectivityAndShipmentStatus(device, 'connectivity_verfication_result')}`);
			device.shipment_quality_result_formatted = this.translateService.instant(`g.${this.commonService.getDeviceConnectivityAndShipmentStatus(device, 'shipment_quality_result')}`);
		});

		return devices;
	}

	prepareInstalledTruckWidget(iotahDevices) {
		const customerSitesInfo = _.indexBy(this.sites, 'id');
		let hasAnyNocPermission = false;
		let hasAnyBasicSetupPermission = false;

		[...iotahDevices].forEach((row) => {
			const { hasNocPermission, hasBasicSetupPermission } = this.installedDeviceWidgetFieldPermission(row.site_id);
			if (hasNocPermission)
				hasAnyNocPermission = true;

			if (hasBasicSetupPermission)
				hasAnyBasicSetupPermission = true;
		});

		const devicesGridCols: ColumnsConfig[] = [
			{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: 'link' },
			{ key: "serial_number", name: this.translateService.instant("g.iotah_sn"), type: 'string' },
		];

		if (hasAnyNocPermission)
			devicesGridCols.push({ key: "fw_version", name: this.translateService.instant("devices.fw_version"), type: 'number' });

		devicesGridCols.push(
			{ key: 'truck_sn', name: this.translateService.instant('devices.truck_sn'), type: 'link'},
		)

		if (hasAnyBasicSetupPermission)
			devicesGridCols.push({ key: 'truck_id', name: this.translateService.instant('devices.truck_id'), type: 'link'});

		devicesGridCols.push(
			{ key: 'truck_manufacturer', name: this.translateService.instant('devices.truck_manufacturer'), type: 'string' },
			{ key: "truck_type", name: this.translateService.instant("devices.truck_type"), type: 'string', hidden: true },
			{ key: "mac_address", name: this.translateService.instant("devices.unique_mac_address"), type: 'string', hidden: true },
			{ key: "hw_version", name: this.translateService.instant("devices.hw_version"), type: 'string', hidden: true },
			{ key: "ip_address", name: this.translateService.instant("g.ip_address"), type: 'string' },
			{ key: "_voltage", name: this.translateService.instant("rt.voltage"), type: 'number' },
			{ key: "battery_capacity", name: this.translateService.instant("devices.battery_capacity"), type: 'number' },
			{ key: "_installation_date_ms", name: this.translateService.instant("devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "last_connect_time_formatted", name: this.translateService.instant("devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('devices.last_connected_in'), type: "string" },
		);

		if (hasAnyNocPermission)
			devicesGridCols.push(
				{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("connectivity_verification.connectivity_verification_status"), type: 'link' },
				{ key: "shipment_quality_result_formatted", name: this.translateService.instant("devices.shipment_quality_checked"), type: 'link' },
			);

		this.commonService.applyTimeSourceTooltips(devicesGridCols, this.timeSourceByColumn);
		this.installedCustomerIotahDeviceTableConfig.column = devicesGridCols;
		const filteredIotahDevices = [];
		[...iotahDevices].forEach((row) => {
			const { hasNocPermission, hasBasicSetupPermission } = this.installedDeviceWidgetFieldPermission(row.site_id);

			let rowData: TableData = {
				site_name: { value: customerSitesInfo[row.site_id].name, link: ['/', customerSitesInfo[row.site_id].customer_id, customerSitesInfo[row.site_id].id] },
				serial_number: { value: row.serial_number },
				fw_version: { value: hasNocPermission ? row.fw_version : '-' },
				truck_sn: { value: row.truck_sn, link: row.truck_sn ? ['/', customerSitesInfo[row.site_id].customer_id, customerSitesInfo[row.site_id].id, row.mac_address, 'performance'] : null },
				truck_id: { value: hasBasicSetupPermission ? row.truck_id : '-' },
				truck_manufacturer: {value: row.truck_manufacturer },
				truck_type: { value: row.truck_type },
				mac_address: { value: row.mac_address },
				hw_version: { value: row.hw_version },
				ip_address: { value: row.ip_address },
				_voltage: { value: row._voltage },
				battery_capacity: { value: row.battery_capacity },
				_installation_date_ms: { value: row._installation_date_ms },
				last_connect_time_formatted: { value: row.last_connect_time_formatted },
				last_connected_in: {value: this.commonService.getLastConnectedIn(row.last_connect_time || 0), sortValue: moment().utc().unix() - +row.last_connect_time },
				connectivity_verfication_status_formatted: { value: hasNocPermission ? row.connectivity_verfication_status_formatted : '-', link: hasNocPermission && row.connectivity_verfication_result && row.connectivity_verfication_result.report_id? ['/', 'admin-panel', 'connectivity-verification-log', row.connectivity_verfication_result?.report_id] : null},
				shipment_quality_result_formatted: { value: hasNocPermission ? row.shipment_quality_result_formatted : '-', link: hasNocPermission && row.shipment_quality_result && row.shipment_quality_result.report_id? ['/', 'management', 'shipment-quality-history', row.shipment_quality_result?.report_id] : null}
			}

			filteredIotahDevices.push(rowData);
		});
		this.installedCustomerIotahDeviceTableConfig.data = filteredIotahDevices;
	}

	prepareInstalledChargesWidget(chargeLinkDevices) {
		const customerSitesInfo = _.indexBy(this.sites, 'id');
		let hasAnyNocPermission = false;
		let hasAnyBasicSetupPermission = false;

		[...chargeLinkDevices].forEach((row) => {
			const { hasNocPermission, hasBasicSetupPermission } = this.installedDeviceWidgetFieldPermission(row.site_id);
			if (hasNocPermission)
				hasAnyNocPermission = true;

			if (hasBasicSetupPermission)
				hasAnyBasicSetupPermission = true;
		});

		let devicesGridCols: ColumnsConfig[] = [
			{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: 'link' },
			{ key: "serial_number", name: this.translateService.instant("chargLinkDevice.g.iotah_sn"), type: 'string' },
		];

		if (hasAnyNocPermission)
			devicesGridCols.push({key: "fw_version", name: this.translateService.instant("devices.fw_version"), type: 'number'});

		devicesGridCols.push(
			{ key: 'truck_sn', name: this.translateService.instant('chargLinkDevice.devices.truck_sn'), type: 'link'},
			{ key: 'truck_id', name: this.translateService.instant('chargLinkDevice.devices.truck_id'), type: 'link'},
			{ key: 'truck_manufacturer', name: this.translateService.instant('devices.charger_manufacturer'), type: 'string' },
			{ key: "truck_type", name: this.translateService.instant("chargLinkDevice.devices.truck_type"), type: 'string', hidden: true },
		);

		if (hasAnyBasicSetupPermission)
			devicesGridCols.push({ key: 'max_charger_kw', name: this.translateService.instant("chargLinkDevice.devices.charger_max_power"), type: 'number', noValueString: '-'});

		devicesGridCols.push(
			{ key: "mac_address", name: this.translateService.instant("devices.unique_mac_address"), type: 'string', hidden: true },
			{ key: "hw_version", name: this.translateService.instant("devices.hw_version"), type: 'string', hidden: true },
			{ key: "ip_address", name: this.translateService.instant("g.ip_address"), type: 'string' },
			{ key: "_voltage", name: this.translateService.instant("rt.voltage"), type: 'number', noValueString: '-'},
			{ key: "_installation_date_ms", name: this.translateService.instant("devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "last_connect_time_formatted", name: this.translateService.instant("devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('devices.last_connected_in'), type: "string" },
		);

		if (hasAnyNocPermission)
			devicesGridCols.push(
			{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("connectivity_verification.connectivity_verification_status"), type: 'link' },
			{ key: "shipment_quality_result_formatted", name: this.translateService.instant("devices.shipment_quality_checked"), type: 'link' },
		);

		this.commonService.applyTimeSourceTooltips(devicesGridCols, this.timeSourceByColumn);
		this.installedCustomerChargersDeviceTableConfig.column = devicesGridCols;
		const filteredCharglinkDevices = [];
		[...chargeLinkDevices].forEach((row) => {
			const { hasNocPermission, hasBasicSetupPermission } = this.installedDeviceWidgetFieldPermission(row.site_id);

			let rowData: TableData = {
				site_name: { value: customerSitesInfo[row.site_id].name, link: ['/', customerSitesInfo[row.site_id].customer_id, customerSitesInfo[row.site_id].id] },
				serial_number: { value: row.serial_number },
				fw_version: { value: hasNocPermission ? row.fw_version : '-'},
				truck_sn: { value: row.truck_sn, link: row.truck_sn ? ['/', customerSitesInfo[row.site_id].customer_id, customerSitesInfo[row.site_id].id, row.mac_address, 'performance'] : null },
				truck_id: { value: row.truck_id},
				truck_manufacturer: { value: row.truck_manufacturer },
				truck_type: { value: row.truck_type },
				max_charger_kw: { value: hasBasicSetupPermission ? row.max_charger_kw : '-' },
				mac_address: { value: row.mac_address },
				hw_version: { value: row.hw_version },
				ip_address: { value: row.ip_address },
				_voltage: { value: row._voltage },
				_installation_date_ms: { value: row._installation_date_ms },
				last_connect_time_formatted: { value: row.last_connect_time_formatted },
				last_connected_in: {value: this.commonService.getLastConnectedIn(row.last_connect_time || 0), sortValue: moment().utc().unix() - +row.last_connect_time },
				connectivity_verfication_status_formatted: { value: hasNocPermission ? row.connectivity_verfication_status_formatted : '-', link: hasNocPermission && row.connectivity_verfication_result && row.connectivity_verfication_result.report_id? ['/', 'admin-panel', 'connectivity-verification-log', row.connectivity_verfication_result?.report_id] : null},
				shipment_quality_result_formatted: { value: hasNocPermission ? row.shipment_quality_result_formatted : '-', link: hasNocPermission && row.shipment_quality_result && row.shipment_quality_result.report_id? ['/', 'management', 'shipment-quality-history', row.shipment_quality_result?.report_id] : null}
			}
			filteredCharglinkDevices.push(rowData);
		});
		this.installedCustomerChargersDeviceTableConfig.data = filteredCharglinkDevices;
	}

	prepareInstalledBatteryWidget(battlinkDevices) {
		const customerSitesInfo = _.indexBy(this.sites, 'id');
		let hasAnyNocPermission = false;

		[...battlinkDevices].forEach((row) => {
			const { hasNocPermission } = this.installedDeviceWidgetFieldPermission(row.site_id);
			if (hasNocPermission)
				hasAnyNocPermission = true;
		});

		let devicesGridCols: ColumnsConfig[] = [
			{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: 'link' },
			{ key: "serial_number", name: this.translateService.instant("battlinkDevice.g.iotah_sn"), type: 'string' },
			{ key: 'truck_id', name: this.translateService.instant('battlinkDevice.devices.truck_id'), type: 'string'},
			{ key: 'truck_manufacturer', name: this.translateService.instant('battlinkDevice.devices.truck_manufacturer'), type: 'string' },
			{ key: 'truck_sn', name: this.translateService.instant('battlinkDevice.smart_rebates_reports.truck_sn'), type: 'link'},
			{ key: "_voltage", name: this.translateService.instant("battlinkDevice.devices.battery_voltage"), type: 'number' },
			{ key: "battery_capacity", name: this.translateService.instant("devices.battery_capacity"), type: 'number' },
			{ key: "_installation_date_ms", name: this.translateService.instant("devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "last_connect_time_formatted", name: this.translateService.instant("devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('devices.last_connected_in'), type: "string" },
			{ key: "last_longitude", name: this.translateService.instant("battlinkDevice.devices.last_battery_long"), type: 'number' },
			{ key: "last_latitude", name: this.translateService.instant("battlinkDevice.devices.last_battery_lat"), type: 'number' },
		];

		if (hasAnyNocPermission) {
			devicesGridCols.push(
				{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("connectivity_verification.connectivity_verification_status"), type: 'link' },
				{ key: "shipment_quality_result_formatted", name: this.translateService.instant("devices.shipment_quality_checked"), type: 'link' },
			);
		}

		this.commonService.applyTimeSourceTooltips(devicesGridCols, this.timeSourceByColumn);
		this.installedCustomerBatteryDeviceTableConfig.column = devicesGridCols;

		let filteredBattlinkDevices = [];
		[...battlinkDevices].forEach((row) => {
			const { hasNocPermission } = this.installedDeviceWidgetFieldPermission(row.site_id);

			let rowData: TableData = {
				site_name: { value: customerSitesInfo[row.site_id].name, link: ['/', customerSitesInfo[row.site_id].customer_id, customerSitesInfo[row.site_id].id] },
				serial_number: {value: row.serial_number },
				truck_id: {value: row.truck_id},
				truck_manufacturer: {value: row.truck_manufacturer},
				truck_sn: {value: row.truck_sn, link: row.truck_sn ? ['/', customerSitesInfo[row.site_id].customer_id, customerSitesInfo[row.site_id].id, row.mac_address, 'performance'] : null },
				_voltage: {value: row._voltage},
				battery_capacity: {value: row.battery_capacity},
				_installation_date_ms: {value: row._installation_date_ms },
				last_connect_time_formatted: {value: row.last_connect_time_formatted },
				last_connected_in: {value: this.commonService.getLastConnectedIn(row.last_connect_time || 0), sortValue: moment().utc().unix() - +row.last_connect_time },
				last_longitude: {value: row.last_longitude},
				last_latitude: {value: row.last_latitude},
				connectivity_verfication_status_formatted: {value: hasNocPermission ? row.connectivity_verfication_status_formatted : '-', link: hasNocPermission && row.connectivity_verfication_result && row.connectivity_verfication_result.report_id? ['/', 'admin-panel', 'connectivity-verification-log', row.connectivity_verfication_result?.report_id] : null},
				shipment_quality_result_formatted: {value: hasNocPermission ? row.shipment_quality_result_formatted : '-', link: hasNocPermission && row.shipment_quality_result && row.shipment_quality_result.report_id? ['/', 'management', 'shipment-quality-history', row.shipment_quality_result?.report_id] : null}
			}
			filteredBattlinkDevices.push(rowData);
		});

		this.installedCustomerBatteryDeviceTableConfig.data = filteredBattlinkDevices;
	}

	installedDeviceWidgetFieldPermission (deviceSiteId) {
		const deviceSitePermission = this.customerSitesPermissions[deviceSiteId] || {};
		const hasNocPermission = this.userService.hasAccessPermission({ permission: deviceSitePermission }, 'noc');
		const hasBasicSetupPermission = this.userService.hasAccessPermission({ permission: deviceSitePermission }, 'basic_setup');
		return {
			hasNocPermission: hasNocPermission,
			hasBasicSetupPermission: hasBasicSetupPermission
		}
	}
}
